import { Component } from '@angular/core';
import { ExtensionDocumentPipe } from '@shared/filters/extension-document/extension-document.pipe';
import { AfTranslateDirective } from '@shared/modules/translate/directive/af-translate.directive';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { FieldTypeListSimpleComponent } from "../field-type-list/field-type-list-simple/field-type-list-simple.component";
import { AfTranslateFactory } from '@shared/modules/translate/factory/translate.factory';
import { ApiServiceService } from '@shared/services/api-service/api-service.service';
import { LoaderFactory } from '@shared/factories/loader/loader.factory';
import { ModalServiceService } from '@shared/services/modal-service/modal-service.service';

@Component({
  selector: 'change-association-modal',
  standalone: true,
  imports: [
    AfTranslateDirective,
    ExtensionDocumentPipe,
    FieldTypeListSimpleComponent
],
  templateUrl: './change-association-modal.component.html'

})
export class ChangeAssociationModalComponent {
  document: any = this.dialogConfig.data.document;
  processSteps: any = this.dialogConfig.data.processSteps;
  listSelectShow: any = this.dialogConfig.data.listSelectShow;
  stateId: any = this.dialogConfig.data.stateId;
  hasStateId: boolean = Boolean(this.dialogConfig.data.stateId && this.dialogConfig.data.stateId !== null);
  title: string = this.dialogConfig.data.title;
  processSelect: any = null;
  desassociateDocument: boolean = false;
  stateSelected: any;
  constructor(
    private dialogRef: DynamicDialogRef<ChangeAssociationModalComponent>,
    private dialogConfig: DynamicDialogConfig,
    private translate: AfTranslateFactory,
    private apiService:ApiServiceService,
    private loader: LoaderFactory,
    private modalService: ModalServiceService
  ){}

  selectProcess(ev:any){
    this.processSelect = ev.newValue;
    this.stateSelected = this.listSelectShow.filter((item:any)=>{return item.stateId === this.processSelect})[0]
  }

  changeAssociated(){
    if(this.processSelect !== null){
      this.loader.openLoader('associate-document-change')
      this.associateDocument(`documentobjects/${this.document.documentObjectId}/state/${this.processSelect}`);
    }else{
      this.modalService.errorModal({text: this.translate.instant('change-association.error-to-associated')})
      this.processSteps.error = true;
    }
  }

  associateDocument(url:string){
    this.apiService.patch(url)
      .then((data:any)=>{
        this.loader.closeLoader(['associate-document-change']);
        if(this.desassociateDocument){
          this.document.stateProcess = '';
          this.document.state = null;
          this.dialogRef.close({
            result: 'unlink',
            document: this.document
          })
        }else{

          this.document.stateProcess = this.stateSelected.name;
          this.document.state = {
              name: this.stateSelected.name,
              stateId: this.stateSelected.stateId
          }
          this.dialogRef.close({
            result : this.hasStateId?'change-state' : 'new-association',
            processSelect: this.processSelect
          })

        }

            // if(this.associatedDocument.desassociateDocument){
            //     this.document.stateProcess = '';
            //     this.document.state = null;
            // }
        //     this.changeState(this.concept.documentation);
        //     this.handleAccept();
        // }
    }, (errorData:any)=>{
      this.loader.closeError()
      this.modalService.errorModal({ text: this.translate.instant('process.modal.error-change-document') });
    })
  }

  handleDismiss() {
    this.dialogRef.close({result:'cancel'});
  }



}
